import Link from "next/link";
import { FC } from "react";
import { ArrowNarrowLeftIcon } from "@heroicons/react/outline";
import { IMegamenuItem } from "features/home/helpers/types";

interface Props {
  activeLevel: IMegamenuItem | undefined;
  onClose: () => void;
}

const HeaderMegaMenu: FC<Props> = ({ activeLevel, onClose }) => {
  return (
    <Link href={activeLevel?.url || "/explore"} prefetch={false}>
      <button
        className="mt-3 mb-2.5 mr-3 flex items-center justify-center gap-2 py-2 px-3 text-right text-sm font-normal leading-5 text-zinc-500 hover:text-[#1E88E5] focus:text-[#125289] disabled:text-zinc-300"
        onClick={onClose}
      >
        {activeLevel?.name
          ? `همه آموزش‌های ${activeLevel?.name}`
          : "همه آموزش‌ها"}
        <ArrowNarrowLeftIcon className="h-4 w-4" />
      </button>
    </Link>
  );
};

export default HeaderMegaMenu;
